import React from 'react';
import PropTypes from "prop-types";

import {getRangeFromDates} from "./date_range_utils";
import {DATE_RANGE_CUSTOM} from "../../../constants/dates";
import DatePicker from "../DatePicker";

function Dates({from, till, onUpdate}) {
    if (getRangeFromDates(from, till) === DATE_RANGE_CUSTOM) {
        return (
            <div className="mindsets-custom-date-range">
                <DatePicker
                    range={true}
                    date={from && till ? [from, till] : null}
                    onChange={onUpdate}
                />
            </div>
        );
    }

    return null;
}

Dates.propTypes = {
    onUpdate: PropTypes.func.isRequired,
    from: PropTypes.number,
    till: PropTypes.number
}

export default Dates;
